import { TransactionCurrency } from '@contracts/payment/Currency';
import { PermitMeasurementContext } from '@src/common/measurements/PermitMeasurementContext';
import type { ReactNode } from 'react';
import { useState } from 'react';

export const PermitMeasurementContextProvider = ({
  children,
  permitTypeCurrency,
}: {
  children: ReactNode;
  permitTypeCurrency: TransactionCurrency;
}) => {
  const [showInMetric, setShowInMetric] = useState<boolean>(
    permitTypeCurrency === TransactionCurrency.CAD,
  );

  return (
    <PermitMeasurementContext.Provider
      value={{ showInMetric, setShowInMetric }}
    >
      {children}
    </PermitMeasurementContext.Provider>
  );
};
